import { DisplayMode } from '@rta/rta-blueprint-component';

import { DefaultState } from './default-state.type';

export const defaultState: DefaultState = {
	displayMode: DisplayMode.Overhead
};
